import { _ as __decorate } from '../tslib.es6-Cv888lzs.js';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ItRadio } from '@italia/radio';
import '@italia/icon';

var styles = css`@charset "UTF-8";
*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

:host {
  display: inline-flex;
  padding: 0;
  margin: 0;
  box-shadow: none !important;
  cursor: pointer;
  -webkit-focus-ring-color: transparent;
  outline: none !important;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Focus ring - mostra quando l'item è focalizzato via tastiera */
:host(:focus-visible) #star {
  border-radius: var(--bsi-radius-xs);
  box-shadow: 0 0 0 2px hsl(0, 0%, 100%), 0 0 0 5px hsl(0, 0%, 0%) !important;
  outline: none;
}

.rating-item-control {
  display: inline-flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

/* Nascondi completamente l'input invisibile */
#input {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

/* Stile per l'icona stella */
#star {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  color: var(--bsi-form-control-label-color, #5c6f82);
  transition: color var(--bsi-transition-instant) ease-out, transform 0.1s ease-out;
}
#star:hover {
  transform: scale(1.1);
}

/* Stella vuota quando non checked */
:host(:not([checked])) #star,
:host([aria-checked=false]) #star {
  color: var(--bsi-form-control-label-color, #5c6f82);
}

/* Stato disabled */
:host([disabled]) #star {
  cursor: not-allowed;
  opacity: 0.6;
}`;

/**
 * Rating item component - extends it-radio to render a star icon
 *
 * @element it-rating-item
 *
 * @slot label - The accessibility label for the star (e.g., "Valuta 3 stelle su 5")
 */
let ItRatingItem = class ItRatingItem extends ItRadio {
    /**
     * Override group getter to find parent it-rating instead of it-radio-group
     */
    get group() {
        return this.closest('it-rating');
    }
    get icon() {
        return this.group?.icon || 'it-star-outline';
    }
    /**
     * Override _renderInput to render icon instead of radio circle
     * Now that _renderInput is protected in parent, we can override it
     */
    _renderInput() {
        // Get the parent rating to determine which items should be filled
        const rating = this.closest('it-rating');
        const ratingValue = rating ? parseInt(rating.value || '0', 10) : 0;
        const thisValue = parseInt(this.value || '0', 10);
        // Icon should be filled if its value is <= the rating value
        const isFilled = thisValue <= ratingValue;
        // Use primary color only for filled icons
        const iconColor = isFilled ? 'primary' : 'secondary';
        let renderedIcon = this.icon;
        if (isFilled && this.icon === 'it-star-outline') {
            renderedIcon = 'it-star-full';
        }
        return html `
      <div id="input" part="input"></div>
      <it-icon id="star" part="star" name="${renderedIcon}" size="sm" aria-hidden="true" color="${iconColor}"></it-icon>
    `;
    }
    handleSlotChange() {
        // Notify assistive technologies of label change
        this.labelElements.forEach((el) => {
            el.classList.add('visually-hidden');
        });
    }
    /**
     * Override render to use rating-specific structure
     */
    render() {
        return html `
      <div class="rating-item-control">
        ${this._renderInput()}
        <slot name="label" @slotchange=${this.handleSlotChange}></slot>
      </div>
    `;
    }
};
ItRatingItem.styles = styles;
ItRatingItem = __decorate([
    customElement('it-rating-item')
], ItRatingItem);

export { ItRatingItem };
//# sourceMappingURL=it-rating-item.js.map
